import FloatingButton from './floating-button';

export default FloatingButton;
